import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { EasyEatHqService } from 'src/app/common/services/ee-hq.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { PaymentService } from 'src/app/common/services/payment.service';
import {
  CROSS,
  PAYMENT_OPTIONS,
  PAYMENT_OPTIONS_ID,
  MODAL_CLOSE,
  PAYMENT_CARD,
  PAYMENT_CURLEC,
  PAYMENT_SETTLEMENT,
} from 'src/defaultImages.js';
import { CollectionInfrastructureService } from '../../collection-infrastructure.service';
import { PAYMENT_METHOD } from '../../collection-infrastructure.enums';
import { MessageService } from 'src/app/common/services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-method-modal',
  templateUrl: './payment-method-modal.component.html',
  styleUrls: ['./payment-method-modal.component.css'],
})
export class PaymentMethodModalComponent implements OnInit, OnDestroy {
  images: any = {
    CROSS,
    PAYMENT_OPTIONS,
    MODAL_CLOSE,
    PAYMENT_CARD,
    PAYMENT_CURLEC,
    PAYMENT_SETTLEMENT,
  };
  enum: any = {
    PAYMENT_METHOD,
  };
  isLoading: boolean = false;
  reoccurChecked: boolean = false;
  isMYEnvironment: boolean = false;
  visible: boolean;
  @Input() payload: any = {};
  selectedPaymentMethod: string = PAYMENT_METHOD.ONLINE;
  paymentMethodsMap = {
    online: {
      id: PAYMENT_METHOD.ONLINE,
      name: 'Pay Online',
      img: PAYMENT_OPTIONS,
    },
    curlec: {
      id: PAYMENT_METHOD.CURLEC,
      name: 'Pay via Saved Bank Mandates',
      img: PAYMENT_CURLEC,
    },
    saved_card: {
      id: PAYMENT_METHOD.SAVED_CARD,
      name: 'Pay via Saved Credit Cards',
      img: PAYMENT_CARD,
    },
    settlement: {
      id: PAYMENT_METHOD.SETTLEMENT,
      name: 'Pay via Settlements',
      img: PAYMENT_SETTLEMENT,
    },
  };
  paymentMethods: any = [];
  translationText: any;
  subscription: Subscription = new Subscription();

  constructor(
    private _modalRef: NzModalRef,
    private _payment: PaymentService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _localStorage: LocalStorageService,
    private _hqService: EasyEatHqService,
    private _msg: MessageService,
    private _util: UtilService,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.setTranslation();
    if (this._util.isMyEnvironment()) {
      this.reoccurChecked = true;
      this.isMYEnvironment = true;
    } else {
      this.reoccurChecked = false;
      this.isMYEnvironment = false;
    }
    if (this._hqService.isHqUser()) {
      this.paymentMethods.push(this.paymentMethodsMap[PAYMENT_METHOD.ONLINE]);
    } else {
      this.getPaymentMethodsForCollection();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setTranslation(): void {
    this.subscription.add(
      this._translateService
        .get('PAYMENT_METHOD_MODAL')
        .subscribe((translation) => {
          this.translationText = translation;
          this.paymentMethodsMap = {
            online: {
              id: PAYMENT_METHOD.ONLINE,
              name: this.translationText.PAY_VIA_ONLINE,
              img: this._util.isMyEnvironment()
                ? PAYMENT_OPTIONS
                : PAYMENT_OPTIONS_ID,
            },
            curlec: {
              id: PAYMENT_METHOD.CURLEC,
              name: this.translationText.PAY_VIA_SAVED_BANK_MANDATES,
              img: PAYMENT_CURLEC,
            },
            saved_card: {
              id: PAYMENT_METHOD.SAVED_CARD,
              name: this.translationText.PAY_VIA_SAVED_CARD,
              img: PAYMENT_CARD,
            },
            settlement: {
              id: PAYMENT_METHOD.SETTLEMENT,
              name: this.translationText.PAY_VIA_SETTLEMENTS,
              img: PAYMENT_SETTLEMENT,
            },
          };
        })
    );
  }

  reoccurCheckHandler(event) {
    if ((event || {}).hasOwnProperty('checked')) {
      this.reoccurChecked = event.checked;
    }
  }

  cancelClicked(): void {
    this._modalRef.close({ data: null, status: 0 });
  }

  closePopover(): void {
    this.visible = false;
  }

  async proceedToPaymentPage() {
    this.isLoading = true; // Start loader
    try {
      const res = await this._payment.payNow(
        this.payload.paymentPayload,
        this.selectedPaymentMethod === PAYMENT_METHOD.ONLINE
          ? this.reoccurChecked
          : false,
        {
          ...(this.payload.selectedPlan && {
            selectedPlan: this.payload.selectedPlan,
          }),
          ...(this.payload.payment_description && {
            payment_description: this.payload.payment_description,
          }),
          ...(this.payload.client_id && { client_id: this.payload.client_id }),
          ...(this.payload.return_url && {
            return_url: this.payload.return_url,
          }),
          ...(this.selectedPaymentMethod && {
            payment_method: this.selectedPaymentMethod,
          }),
        }
      );
      if (
        this.selectedPaymentMethod === PAYMENT_METHOD.SETTLEMENT ||
        this.selectedPaymentMethod === PAYMENT_METHOD.SAVED_CARD
      ) {
        if (((res || {}).data || {}).status === 1) {
          this._modalRef.close({
            data: (res || {}).data,
            status: ((res || {}).data || {}).status,
          });
        } else {
          this._msg.showError(((res || {}).data || {}).message || '');
        }
      }
    } catch (error) {
      console.error(error);
      // Handle the error appropriately, maybe show a user-friendly message
    } finally {
      this.isLoading = false; // Stop loader
    }
  }

  async getPaymentMethodsForCollection() {
    const restId = this._localStorage.get('restaurant_id');
    const response: any =
      await this._collectionInfraService.getPaymentMethodsForCollection(
        restId,
        this.payload.client_id
      );
    const data = (response || {}).data || {};
    const status = data.status;
    if (status === 1 || status === 2) {
      (data.methods || []).forEach((method) => {
        this.paymentMethods.push(this.paymentMethodsMap[method]);
      });
    }
  }
}
